import { PubnubAdapter, IframeAdapter } from "@classdojo/web/pods/realtime";
import { isDisplay, isRemote, mountPoint } from "./util/role";
import logEvent from "src/utils/logEvent";

const isRightPlace = (isRemote && mountPoint === "teach") || isDisplay;
const hasCapability = !!(
  typeof window === "object" &&
  // @ts-expect-error ts(2774) Extra safety-check for toolkit, just in case. "This condition will always return true since this function is always defined."
  window.postMessage &&
  window !== window.parent &&
  window.parent.postMessage
);

const params = new URLSearchParams(typeof window !== "undefined" ? window.location.search : undefined);
const parentOrigin = params.get("parentOrigin") || undefined;

export default function getRealtimeAdapter(userId: string) {
  if (isRightPlace && hasCapability) {
    return new IframeAdapter(window, window.parent, parentOrigin);
  } else {
    return new PubnubAdapter({ logEvent, userId });
  }
}
